import * as React from 'react';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { PromoItem } from '../../../components/NewbuildingPromos/parts/PromoItem';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { trackClickPromoBlock } from '../../../utils/tracking/promos/trackClickPromoBlock';
import { trackHoverPromoBlock } from '../../../utils/tracking/promos/trackHoverPromoBlock';
import { NewbuildingPromoDetailsContainer } from '../../NewbuildingPromoDetails';
import { PromoIcon } from './PromoIcon';

interface IPromoProps {
  promo: IPromoInfo;
  offer: IOfferSchema;
}

export function Promo({ promo, offer }: IPromoProps) {
  const [open, setOpen] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handlePromoClick = React.useCallback(() => {
    setOpen(true);
    trackClickPromoBlock({ promo, offer });
  }, [promo, offer]);

  const handleHover = React.useCallback(() => {
    trackHoverPromoBlock({ promo, offer });
  }, [promo, offer]);

  return (
    <>
      <PromoItem promo={promo} onClick={handlePromoClick} onHover={handleHover} icon={<PromoIcon promo={promo} />} />
      <NewbuildingPromoDetailsContainer open={open} onClose={handleClose} promo={promo} offer={offer} />
    </>
  );
}
